import { DefaultPageHeader } from 'layouts';
import { HelpCard } from './help-card';

const Help = () => (
  <>
    <DefaultPageHeader title="Help" />
    <HelpCard />
  </>
);

export default Help;
